import * as THREE from "three";
const getPosInfo = (obj) => {
    if (!obj || typeof obj.updateWorldMatrix !== "function") {
        const bbox = new THREE.Box3(
            new THREE.Vector3(0, 0, 0),
            new THREE.Vector3(0, 0, 0)
        );
        return { bbox, xSize: 0, ySize: 0, zSize: 0, currentPosition: {} };
    }
    const bbox = new THREE.Box3().setFromObject(obj);
    const xSize = bbox.max.x - bbox.min.x;
    const ySize = bbox.max.y - bbox.min.y;
    const zSize = bbox.max.z - bbox.min.z;
    const posInfo = { bbox, xSize, ySize, zSize, currentPosition: {} };
    return posInfo;
}
export default getPosInfo;
